import { getEnv } from "../lib/env";

const env = getEnv();

export class DirectUploadError extends Error {
  status: number | null;

  constructor(message: string, status: number | null = null) {
    super(message);
    this.name = "DirectUploadError";
    this.status = status;
  }
}

export function isLikelyDirectUploadNetworkError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }

  return error.message === "Load failed"
    || error.message === "Failed to fetch"
    || error.message.includes("Network request failed");
}

export async function putFileToSignedUploadUrl({
  uploadUrl,
  file,
  requiredHeaders
}: {
  uploadUrl: string;
  file: File;
  requiredHeaders: Record<string, string>;
}): Promise<void> {
  if (env.enableMock && uploadUrl.includes("upload.mock.local")) {
    return;
  }

  await new Promise<void>((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.open("PUT", uploadUrl);
    xhr.responseType = "text";
    xhr.timeout = 120_000;
    xhr.withCredentials = false;

    const headers = Object.entries(requiredHeaders).length > 0
      ? requiredHeaders
      : { "Content-Type": file.type || "application/octet-stream" };
    for (const [name, value] of Object.entries(headers)) {
      xhr.setRequestHeader(name, value);
    }

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve();
        return;
      }

      reject(new DirectUploadError("ファイルのアップロードに失敗しました。", xhr.status));
    };

    xhr.onerror = () => {
      reject(new Error("Load failed"));
    };

    xhr.onabort = () => {
      reject(new Error("Upload aborted"));
    };

    xhr.ontimeout = () => {
      reject(new Error("Upload timed out"));
    };

    xhr.send(file);
  });
}
